exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-welcome .greetings {\n  color: gray;\n  font-size: 20px;\n  padding-left: 4px; }\n", ""]);

// exports
